import { render } from "./CNCPunch.vue?vue&type=template&id=4a0c317f"
import script from "./CNCPunch.vue?vue&type=script&lang=js"
export * from "./CNCPunch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__